<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="16rem"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">求助详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="预警级别"
        prop="AlerteLevel"
        style="width: 118rem"
        v-if="false"
      >
        <el-select
          v-model="ruleForm.AlerteLevel"
          placeholder="请选择"
          style="width: 100%"
          :disabled="true"
        >
          <el-option
            v-for="item in AlerteLevelArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.Extend1"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="预警类型"
        prop="AlertType"
        style="width: 118rem"
        v-if="false"
      >
        <el-select
          v-model="ruleForm.AlertType"
          placeholder="请选择"
          style="width: 100%"
          :disabled="true"
        >
          <el-option
            v-for="item in AlertTypeArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.Extend1"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预警时间" prop="BeginDate" v-if="IsEdit">
        <el-date-picker
          type="datetime"
          placeholder="选择日期"
          v-model="ruleForm.BeginDate"
          style="width: 40rem"
          :disabled="IsEdit"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="预警结束时间" prop="EndDate" v-if="IsEdit">
      <el-date-picker
        type="datetime"
        placeholder="选择日期"
        v-model="ruleForm.EndDate"
        style="width:40rem;"
        :disabled="IsEdit"
      ></el-date-picker>     
    </el-form-item> -->
      <el-form-item
        label="报警渠道"
        prop="SourceDesc"
        style="width: 60rem; display: inline-block"
      >
        <el-select
          v-model="ruleForm.SourceDesc"
          placeholder="请选择"
          style="width: 100%"
          v-bind:disabled="IsEdit"
        >
          <el-option
            v-for="item in EmergencyChannel"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.Description"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="求助内容" prop="Content" style="width: 118rem">
        <el-input
          type="textarea"
          v-model="ruleForm.Content"
          v-bind:disabled="IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="求助报警人"
        prop="Contact"
        style="width: 60rem; display: inline-block"
      >
        <el-input
          v-model="ruleForm.Contact"
          v-bind:disabled="IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="联系方式"
        prop="Phone"
        style="width: 58rem; display: inline-block"
      >
        <el-input v-model="ruleForm.Phone" v-bind:disabled="IsEdit"></el-input>
      </el-form-item>
      <el-form-item label="求助地点" prop="Location" style="width: 118rem">
        <el-input
          v-model="ruleForm.Location"
          v-bind:disabled="IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="处理状态"
        prop="ProcessStatus"
        style="width: 118rem"
        v-if="IsEdit"
      >
        <el-select
          v-model="ruleForm.ProcessStatus"
          placeholder="请选择"
          style="width: 100%"
          :disabled="IsEdit"
        >
          <el-option
            v-for="item in ProcessStatusArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.ItemValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理方式" prop="ProcessWay" v-if="IsEdit">
        <el-radio-group
          v-model="ruleForm.ProcessWay"
          :disabled="isCompelete"
          @change="changeProcessWay"
        >
          <el-radio label="1">转为应急事件</el-radio>
          <el-radio label="2">已知晓</el-radio>
          <el-radio label="3">忽略</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-if="!isCompelete"
          >提交</el-button
        >
        <!-- <el-button @click="resetForm('')" >重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import utils from "../../../../../../utils";
export default {
  name: "SeekHelpAlarmInfo",
  controller: "UI",
  action: "SeekHelpAlarmInfo",
  data() {
    return {
      ruleForm: {
        AlertType: "13",
        AlerteLevel: "5",
        Content: "",
        BeginDate: "",
        EndDate: "",
        Location: "",
        Source: 3,
        SourceDesc: null,
        ProcessStatus: "",
        // ProcessStatusShow:"", //处理状态显示
        Contact: null,
        Phone: null,
        ProcessWay: null, // 处理方式
      },
      rules: {
        // AlerteLevel: [
        //   { required: true, message: "请选择预警级别", trigger: "change" },
        // ],
        // AlertType: [
        //   { required: true, message: "请选择预警类型", trigger: "change" },
        // ],
        SourceDesc: [
          { required: true, message: "请选择报警渠道", trigger: "change" },
        ],
        Content: [
          { required: true, message: "请填写求助内容", trigger: "blur" },
        ],
        Contact: [
          { required: true, message: "请填写求助报警人", trigger: "blur" },
        ],
        Phone: [
          { required: true, validator: this.validphone, trigger: "blur" },
        ],
        Location: [
          { required: true, message: "请填写求助地点", trigger: "blur" },
        ],
      },
      IsEdit: false,
      AlertTypeArr: [], //预警类型
      AlerteLevelArr: [], //预警级别
      EmergencyChannel: [],
      BusinessChannel: [],
      channelArr: [],
      ProcessStatusArr: [],
      isCompelete: false,
    };
  },
  watch: {
    "ruleForm.AlertType": function () {
      if (this.ruleForm.AlertType == "13") {
        this.channelArr = this.EmergencyChannel;
      } else {
        this.channelArr = this.BusinessChannel;
      }
    },
    channelArr: function () {
      if (this.$route.query.type == "add") {
        this.ruleForm.SourceDesc = null;
      }
    },
  },
  created: function () {
    this.search();
    this.IsEdit = this.$route.query.type == "add" ? false : true;
    this.isCompelete = this.$route.query.type == "look" ? true : false;
    //预警级别
    this.alarmLevel();
    //预警类型
    this.getAlarmType();
    // 预警来源
    this.EmergencyCallChannel();
    this.BusinessCallChannel();
    // 处理状态
    this.getProcessstatus();
  },
  mounted: function () {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then((d) => {
          console.log("预警级别");
          console.log(d);
          this.AlerteLevelArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value) {
        callback(new Error("请输入联系方式"));
      } else if (!utils.isRightMobileNum(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then((d) => {
          // console.log("预警类型")
          // console.log(d)
          this.AlertTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let ResourcesId = this.$route.query.Id;
      if (ResourcesId) {
        let searchInfo = {
          Id: this.$route.query.Id,
        };
        new MyApis.SeekHelpApi()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.ruleForm = r;
            if (r.ProcessStatus == "2") {
              this.isCompelete = true;
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    EmergencyCallChannel() {
      //预警来源
      this.config
        .getUValue("EmergencyCall:HelpChannel", "")
        .then((d) => {
          console.log("求助报警的预警来源");
          console.log(d);
          this.EmergencyChannel = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    BusinessCallChannel() {
      //预警来源
      this.config
        .getUValue("BusinessAlarm:AlarmChanel", "")
        .then((d) => {
          console.log("普通预警的预警来源");
          console.log(d);
          this.BusinessChannel = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getProcessstatus() {
      //预警处理状态
      this.config
        .getUValue("EmergencyCall:ProcessStatus", "")
        .then((d) => {
          console.log("处理状态");
          console.log(d);
          this.ProcessStatusArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    changeProcessWay(val) {
      if (val === "1") {
        this.$confirm("确认转为应急事件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let path = `/plugin/Emergency/UI/NewEvent?AlarmId=${this.ruleForm.Id}`;
          this.$router.push(path);
        });
      }
    },
    save() {
      console.log(this.ruleForm);

      if (this.$route.query.type == "add") {
        let obj = {
          AlertType: this.ruleForm.AlertType,
          AlerteLevel: this.ruleForm.AlerteLevel,
          Content: this.ruleForm.Content,
          Source: 3,
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          Location: this.ruleForm.Location,
          Contact: this.ruleForm.Contact,
          Phone: this.ruleForm.Phone,
          SourceDesc: this.ruleForm.SourceDesc,
        };
        new MyApis.SeekHelpApi()
          .AddItem(obj)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "求助添加";
            this.logInfo.LogMessage = "求助添加成功";
            this.logInfo.ModuleName = "紧急求助";
            this.logInfo.PageName = "求助详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        new MyApis.SeekHelpApi()
          .UpdateItem(this.ruleForm)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "预警处理";
            this.logInfo.LogMessage = "预警处理成功";
            this.logInfo.ModuleName = "紧急求助";
            this.logInfo.PageName = "求助预警详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
  },
};
</script>
